import { BILLING_CHECKOUT_RETURN_PATH } from '@hero/core';

/**
 * Build the Moyasar `callback_url` / `success_url` for an interactive
 * dashboard checkout (subscribe, plan change, addon purchase). Anchors
 * to the current browser origin, so dev / tunnel / staging / production
 * all redirect back to themselves — zero env config required on the
 * frontend.
 *
 * Single source of truth for the path: `BILLING_CHECKOUT_RETURN_PATH`
 * in `@hero/core`. The backend mirrors this via
 * `MOYASAR_CONFIG.renewalCallbackUrl` for the renewal cron (which has
 * no browser context to read `origin` from).
 *
 * NOT a hook — pure function. `window.location.origin` is stable
 * across the page lifetime, so a hook would be ceremony without
 * payoff. Call it inline wherever the URL is needed.
 *
 * @example
 *   const url = buildBillingReturnUrl();
 *   subscribe.mutateAsync({ ..., callbackUrl: url, successUrl: url });
 */
export function buildBillingReturnUrl(): string {
  return `${window.location.origin}${BILLING_CHECKOUT_RETURN_PATH}`;
}
